import { lazy } from 'react';

import { Sell } from '@mui/icons-material';
import { Navigate, Route, Routes } from 'react-router-dom';

import { EntitlementRouteWrapper } from '~/src/app/components/EntitlementRouteWrapper';
import { NavigationMenuCategory } from '~/src/app/components/Layout/components/NavigationMenu';
import { useUserEntitlements } from '~/src/hooks/useUserEntitlements';

import { RateCardManagerShell } from './components/RateCardManagerShell/RateCardManagerShell';

const RateCards = lazy(() => import('./pages/RateCards'));
const RateDiff = lazy(() => import('./pages/RateDiff'));
const ContractMapping = lazy(() => import('./pages/ContractMapping'));
const Approvals = lazy(() => import('./pages/Approvals'));
const ActivityLog = lazy(() => import('./pages/ActivityLog'));

// TODO (RATE-5747): confirm whether to replace isStaff with a dedicated Carrier Ops entitlement.
export const RateCardManagerRoutes = () => {
  const {
    entitlements: { isStaff },
    loading,
  } = useUserEntitlements();

  return (
    <EntitlementRouteWrapper isAccessible={isStaff} loading={loading}>
      <Routes>
        <Route element={<RateCardManagerShell />}>
          <Route element={<RateCards />} path="list" />
          <Route element={<RateDiff />} path="rate-diff" />
          <Route element={<ContractMapping />} path="contract-mapping" />
          <Route element={<Approvals />} path="approvals" />
          <Route element={<ActivityLog />} path="activity-log" />
        </Route>
        <Route element={<Navigate to="list" />} path="*" />
      </Routes>
    </EntitlementRouteWrapper>
  );
};

export const rateCardManagerNavigationCategory: NavigationMenuCategory = {
  icon: <Sell color="secondary" />,
  items: [
    { name: 'rateCardManager.items.rateCards', route: '/rate-cards/list' },
    { name: 'rateCardManager.items.rateDiff', route: '/rate-cards/rate-diff' },
    { name: 'rateCardManager.items.contractMapping', route: '/rate-cards/contract-mapping' },
    { name: 'rateCardManager.items.approvals', route: '/rate-cards/approvals' },
    { name: 'rateCardManager.items.activityLog', route: '/rate-cards/activity-log' },
  ],
  name: 'rateCardManager.title',
};
